const ALLOWED_TAGS = new Set([
  "A",
  "B",
  "STRONG",
  "I",
  "EM",
  "U",
  "BR",
  "P",
  "UL",
  "OL",
  "LI",
]);

/**
 * Whether an href is a safe http(s) or mailto link.
 *
 * @param {string} href Attribute value.
 * @returns {boolean} True when the URL scheme is allowed.
 */
function isSafeHref(href) {
  return /^(https?:|mailto:)/i.test(String(href).trim());
}

/**
 * Recursively strip disallowed tags and attributes from a DOM subtree.
 *
 * @param {ParentNode} root Node whose children are sanitized in place.
 * @returns {void}
 */
function sanitizeNode(root) {
  [...root.childNodes].forEach((child) => {
    if (child.nodeType === Node.COMMENT_NODE) {
      child.remove();
      return;
    }
    if (child.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const tag = child.tagName;
    sanitizeNode(child);

    if (tag === "SCRIPT" || tag === "STYLE") {
      child.remove();
      return;
    }

    if (!ALLOWED_TAGS.has(tag)) {
      child.replaceWith(...child.childNodes);
      return;
    }

    [...child.attributes].forEach((attr) => {
      if (tag === "A" && attr.name === "href" && isSafeHref(attr.value)) {
        return;
      }
      child.removeAttribute(attr.name);
    });

    if (tag === "A") {
      child.setAttribute("target", "_blank");
      child.setAttribute("rel", "noopener noreferrer");
    }
  });
}

/**
 * Keep only basic announcement markup: bold, italic, underline, lists, and links.
 *
 * @param {string} html Raw HTML from title or body.
 * @returns {string} Sanitized HTML safe to render.
 */
export function sanitizeBasicHtml(html) {
  if (!html) {
    return "";
  }
  const template = document.createElement("template");
  template.innerHTML = String(html);
  sanitizeNode(template.content);
  // Textarea newlines are not HTML; keep them as breaks in the rendered notice.
  return template.innerHTML.replace(/\r\n|\r|\n/g, "<br>");
}
